<template>
  <v-dialog v-model="dialog" hide-overlay="true" width="300">
    <v-card>
      <div class="confirm-wrapper">
        <div class="confirm-message">
          {{ popupContext.message }}
        </div>
        <div class="confirm-buttons-wrapper">
          <v-btn
            class="confirm-button"
            outlined
            color="primary"
            v-on="on"
            @click="confirm()"
          >
            Так
          </v-btn>
          <v-btn
            class="confirm-button"
            outlined
            color="primary"
            v-on="on"
            @click="decline()"
          >
            Ні
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import popupEnum from '@/enums/popupEnum';
import PopupEventEnum from '@/enums/PopupEventEnum';

export default {
  name: popupEnum.CONFIRM_POPUP,
  components: {},
  props: {
    popupContext: {
      type: Object,
      requred: true,
    },
  },
  data() {
    return {
      dialog: true,
    };
  },
  watch: {
    dialog(val) {
      const type = val ? PopupEventEnum.OPEN_POPUP : PopupEventEnum.CLOSE_POPUP;
      this.emit(type);
    },
  },
  computed: {},
  mounted() {},
  destroyed() {
    this.closePopup();
  },
  methods: {
    closePopup() {
      this.dialog = false;
    },
    confirm() {
      this.emit(PopupEventEnum.CONFIRM, this.popupContext.item);
    },
    decline() {
      this.emit(PopupEventEnum.DECLINE);
    },
    emit(type, data = {}) {
      this.$emit('popupEvent', {
        type,
        data,
      });
    },
  },
};
</script>

<style lang="less">
.confirm-wrapper {
  display: flex;
  flex-direction: column;

  .confirm-message {
    margin: auto;
    margin-top: 10px;
  }
  .confirm-buttons-wrapper {
    margin: auto;
    .confirm-button {
      margin: 10px;
    }
  }
}
</style>
